// extracted by mini-css-extract-plugin
export default {"links":"contact_links__CX9MX","info":"contact_info__t83xP","break":"contact_break__kH-nB"};